import { useApplicantContext } from '@/components/providers/ApplicantContextProvider';
import { forwardRef } from 'react';
import { ContentWrapper } from '../Applicant.StyledComponents';
import { ApplicationView } from './ApplicationView';

export const ApplicantInfoWrapper = forwardRef<HTMLDivElement>((_, ref) => {
    const { applicant } = useApplicantContext();

    if (!applicant) return <></>;

    return (
        <ContentWrapper id="printSection" ref={ref} data-testid="applicant-information">
            <ApplicationView applicant={applicant} />
        </ContentWrapper>
    );
});
